import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';


import { WatchersEnterQRkeyComponent } from './watchers-enter-qrkey/watchers-enter-qrkey.component';	 
 import {ResetPasswordPageComponent} from './reset-password-page/reset-password-page.component';
import {ProfilePageComponent} from "./profile-page/profile-page.component"; 
import {LoginPageComponent} from "./login-page/login-page.component";
import {AuthLayoutComponent} from "./shared/layouts/auth-layout/auth-layout.component";
import {SiteLayoutComponent} from "./shared/layouts/site-layout/site-layout.component";
 
import {RegisterPageComponent} from "./register-page/register-page.component";
import {ChannelEditPageComponent} from "./channel-edit-page/channel-edit-page.component";
import {AuthGuard} from "./shared/classes/auth.guard";
import  {PublicStatPageComponent} from './public-stat-page/public-stat-page.component';
import  {PartnerStatPageComponent} from './partner-stat-page/partner-stat-page.component';
import {OverviewPageComponent} from "./overview-page/overview-page.component"; 
import {StreamPageComponent} from "./stream-page/stream-page.component"; 
import {VideoPageComponent} from "./video-page/video-page.component"; 
import { WatchersLayoutComponent } from './shared/layouts/watchers-layout/watchers-layout.component';
import { ChannelsLayoutComponent } from './shared/layouts/channels-layout/channels-layout.component';
import {WatchersPageComponent} from './watchers-page/watchers-page.component';
import {OverviewRestreamsPageComponent} from "./overview-restreams-page/overview-restreams-page.component"; 
import {PlaylistPageComponent} from './playlist-page/playlist-page.component';
import {WatchersEmbedPageComponent} from './watchers-embed-page/watchers-embed-page.component';
import {ChatEmbedPageComponent} from './chat-embed-page/chat-embed-page.component';
import {OverviewVideoPageComponent} from './overview-video-page/overview-video-page.component';
import {StatisticsPageComponent} from './statistics-page/statistics-page.component';
import {IncomePageComponent} from './income-page/income-page.component';
import {IncomeInnerPageComponent} from './income-page/income-inner-page/income-inner-page.component';

import {StatisticsInnerPageComponent} from './statistics-page/statistics-inner-page/statistics-inner-page.component';
import {OverviewPlaylistPageComponent} from './overview-playlist-page/overview-playlist-page.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import {ExpensesPageComponent} from './expenses-page/expenses-page.component';
import {
  NbAuthComponent,  
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';


export const routes: Routes = [
 
 {
    path: '', component: NbAuthComponent, children: [
    {path: '', redirectTo: '/login', pathMatch: 'full'},
      {path: 'login', component: LoginPageComponent},
      {path: 'registration', component: RegisterPageComponent},
	{path:'reset-password', component:ResetPasswordPageComponent},
	 {path: 'page-not-found', component: PageNotFoundComponent}
    ]
  },
  {path: 'stat', component:ChannelsLayoutComponent , children:[{ path:':id', component: PublicStatPageComponent }]},
  {path: 'partstat', component:ChannelsLayoutComponent , children:[{ path:':id', component: PartnerStatPageComponent }]},



  {path: 'qr-enter', component:ChannelsLayoutComponent , children:[{ path:':streamWatchId/:sessionKey', component: WatchersEnterQRkeyComponent }]},

  {
    path: '', component: SiteLayoutComponent, canActivate: [AuthGuard], children: [

	{path: 'expenses', component: ExpensesPageComponent},



      {path: 'overview', component: OverviewPageComponent},
            {path: 'restreams', component: OverviewRestreamsPageComponent},
      {path: 'stream/:id', component: StreamPageComponent},
      {path: 'vid/:id', component: VideoPageComponent},
      {path: 'playlist/:id', component: PlaylistPageComponent},


	{path: 'channel-edit', component: ChannelEditPageComponent},
	{path: 'vid-overview', component: OverviewVideoPageComponent},
	{path: 'playlists', component: OverviewPlaylistPageComponent},
//
	{path: 'statistics', component: StatisticsPageComponent},
	{path: 'income', component: IncomePageComponent},
	{path: 'income/:id', component: IncomeInnerPageComponent},
	//
	 {path: 'statistics/:stream', component: StatisticsInnerPageComponent},
		
//

	{path: 'profile', component: ProfilePageComponent},
 	  {path: 'admin', /* component: SiteLayoutComponent,  , */ loadChildren: './admin/admin.module#AdminModule'},
    ]
  },

	  {path: 'channel',  component: ChannelsLayoutComponent,  loadChildren: './channels/channels.module#ChannelsModule'},
  {
    path: '', component: ChannelsLayoutComponent, children: [
       {path: 'watch', component: WatchersPageComponent},
       {path: 'watch-embed', component: WatchersEmbedPageComponent},
       {path: 'chat-embed', component: ChatEmbedPageComponent}
 
     ]
  },
 
 
  { path: '**', redirectTo: '/page-not-found' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
